import { ISignupForm } from 'utils/form/types';

export interface IAuthRouteParams {
  showOtpForm?: boolean;
  activeRouteIsSignIn?: boolean;
  attemptedSignUpWithExistingEmail?: boolean;
  hasSignedOut?: boolean;
  errorMessage?: string;
  triggerSignInAccessibility?: boolean;
  email?: string;
  currentTabKey?: string;
}

export type UpdateUserInfoOptions = {
  shouldThrowException?: boolean;
  shouldMuteUserInfoErrors?: boolean;
};

export enum ModalAuthScreen {
  SIGN_IN = 'sign-in',
  SIGN_UP = 'sign-up',
  CHALLENGE = 'challenge',
  CLOSED = 'closed',
}

export type ModalAuthState = {
  screen?: ModalAuthScreen;
  errorMessage?: string;
  user?: Partial<Pick<ISignupForm, 'email' | 'name'>>;
  loginForVendorIsLoading?: boolean;
};
